// src/pages/NotFound.js
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom'; 
import { FaHome } from 'react-icons/fa';
import { motion } from 'framer-motion';

const NotFound = () => {
  useEffect(() => {
    document.title = '404 - Page Not Found | Serrand';
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-purple-50 to-pink-100 flex items-center justify-center p-4">
      <div className="max-w-4xl w-full text-center">
        {/* Animated 404 title */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.6, type: 'spring', stiffness: 120 }}
          className="mb-10"
        >
          <h1 className="text-8xl md:text-9xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600 mb-4">
            404
          </h1>
          <div className="w-48 h-2 mx-auto bg-gradient-to-r from-purple-600 to-pink-600 rounded-full"></div>
        </motion.div>

        {/* Content */}
        <motion.div
          initial={{ y: 60, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.7 }}
          className="space-y-6"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800">
            Oops! Page Not Found
          </h2>

          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            The page you're looking for might have been moved, deleted, or never existed.
          </p>

          {/* Animated 404 cube / card */}
          <div className="relative w-64 h-64 mx-auto my-10">
            <motion.div
              animate={{ rotateY: 360 }}
              transition={{ duration: 12, repeat: Infinity, ease: 'linear' }}
              className="w-full h-full perspective-1000"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-purple-500 to-pink-500 rounded-2xl shadow-2xl transform rotate-12 hover:rotate-0 transition-transform duration-500">
                <div className="absolute inset-3 bg-white rounded-xl flex items-center justify-center">
                  <span className="text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">
                    404
                  </span>
                </div>
              </div>
            </motion.div>
          </div>

          {/* Back button with Framer hover/tap */}
          <motion.div
            whileHover={{ scale: 1.08, boxShadow: '0 20px 40px rgba(139, 92, 246, 0.3)' }}
            whileTap={{ scale: 0.95 }}
          >
            <Link
              to="/"
              className="inline-flex items-center gap-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white px-10 py-5 rounded-full font-semibold text-xl shadow-xl hover:shadow-2xl transition-all duration-300"
              aria-label="Return to Homepage"
            >
              <FaHome className="text-2xl" />
              <span>Back to Homepage</span>
            </Link>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;
